// Mock catalog data. In production this is served by GET /api/books from the Express/MongoDB API.

export const genres = [
  'Fiction', 'Non-Fiction', 'Fantasy', 'Sci-Fi', 'Romance',
  'Mystery & Thriller', 'Biography', 'Self-Help', 'History', 'Business',
];

export const languages = ['English', 'Hindi', 'Spanish', 'French'];

const cover = (seed, w = 400, h = 600) => `https://picsum.photos/seed/${seed}/${w}/${h}`;

export const authors = [
  {
    id: 'a1',
    name: 'Elena Marchetti',
    slug: 'elena-marchetti',
    avatar: cover('elena-marchetti', 200, 200),
    bio: 'Elena Marchetti writes literary fiction exploring memory and migration. Her debut novel was longlisted for three international prizes.',
    followers: 48200,
    books: 4,
  },
  {
    id: 'a2',
    name: 'Rowan Kestrel',
    slug: 'rowan-kestrel',
    avatar: cover('rowan-kestrel', 200, 200),
    bio: 'Rowan Kestrel is a speculative fiction author known for richly built worlds and morally complex protagonists.',
    followers: 132000,
    books: 7,
  },
  {
    id: 'a3',
    name: 'Priya Nandakumar',
    slug: 'priya-nandakumar',
    avatar: cover('priya-nandakumar', 200, 200),
    bio: 'Priya Nandakumar writes on behavioral economics and decision-making, translating research into practical guidance.',
    followers: 61500,
    books: 3,
  },
  {
    id: 'a4',
    name: 'Marcus Webb',
    slug: 'marcus-webb',
    avatar: cover('marcus-webb', 200, 200),
    bio: 'Marcus Webb is a former investigative journalist turned thriller novelist, praised for meticulous plotting.',
    followers: 89300,
    books: 6,
  },
  {
    id: 'a5',
    name: 'Ada Solberg',
    slug: 'ada-solberg',
    avatar: cover('ada-solberg', 200, 200),
    bio: 'Ada Solberg writes on design, focus, and building calm creative practices in a distracted world.',
    followers: 27100,
    books: 2,
  },
];

const authorFor = (id) => authors.find((a) => a.id === id);

export const books = [
  {
    id: 'b1', title: 'The Weight of Salt', slug: 'the-weight-of-salt',
    authorId: 'a1', genre: 'Fiction', language: 'English', format: ['PDF'],
    price: 349, mrp: 499, rating: 4.6, reviewsCount: 812, pages: 342,
    published: '2025-03-14', cover: cover('weight-of-salt'), badge: 'Editor\'s Pick',
    description: 'A multigenerational story of a family scattered across three coastlines, and the letters that quietly held them together for forty years.',
    tags: ['literary', 'family', 'diaspora'],
  },
  {
    id: 'b2', title: 'Ashcrown', slug: 'ashcrown',
    authorId: 'a2', genre: 'Fantasy', language: 'English', format: ['PDF'],
    price: 429, mrp: 599, rating: 4.8, reviewsCount: 2140, pages: 512,
    published: '2025-06-02', cover: cover('ashcrown'), badge: 'Bestseller',
    description: 'When the last ember-throne falls silent, an exiled cartographer must redraw a kingdom\'s borders in blood and ink before winter closes the passes.',
    tags: ['epic fantasy', 'political intrigue'],
  },
  {
    id: 'b3', title: 'Nine Minor Regrets', slug: 'nine-minor-regrets',
    authorId: 'a4', genre: 'Mystery & Thriller', language: 'English', format: ['PDF'],
    price: 299, mrp: 399, rating: 4.4, reviewsCount: 954, pages: 288,
    published: '2024-11-20', cover: cover('nine-minor-regrets'), badge: 'New Release',
    description: 'A retired detective is pulled back for one final case: a string of unsolved disappearances that all trace back to the same quiet street.',
    tags: ['crime', 'small town'],
  },
  {
    id: 'b4', title: 'The Attention Ledger', slug: 'the-attention-ledger',
    authorId: 'a3', genre: 'Business', language: 'English', format: ['PDF'],
    price: 0, mrp: 349, rating: 4.3, reviewsCount: 620, pages: 210,
    published: '2025-01-09', cover: cover('attention-ledger'), badge: 'Free',
    description: 'A practical framework for treating focus as a finite budget, drawn from a decade of behavioral research and real workplace experiments.',
    tags: ['productivity', 'behavioral economics'],
  },
  {
    id: 'b5', title: 'Quietly, the Garden', slug: 'quietly-the-garden',
    authorId: 'a5', genre: 'Self-Help', language: 'English', format: ['PDF'],
    price: 249, mrp: 249, rating: 4.7, reviewsCount: 410, pages: 176,
    published: '2025-05-18', cover: cover('quietly-the-garden'),
    description: 'A slow, seasonal guide to building a creative practice that survives busy months — built around small, repeatable rituals.',
    tags: ['mindfulness', 'creativity'],
  },
  {
    id: 'b6', title: 'Ferrous', slug: 'ferrous',
    authorId: 'a2', genre: 'Sci-Fi', language: 'English', format: ['PDF'],
    price: 379, mrp: 449, rating: 4.5, reviewsCount: 1330, pages: 398,
    published: '2024-09-11', cover: cover('ferrous'), badge: 'Trending',
    description: 'On a mining colony where memory can be traded like currency, one engineer discovers her own past has already been sold.',
    tags: ['hard sci-fi', 'memory'],
  },
  {
    id: 'b7', title: 'Letters I Never Sent', slug: 'letters-i-never-sent',
    authorId: 'a1', genre: 'Romance', language: 'English', format: ['PDF'],
    price: 199, mrp: 299, rating: 4.2, reviewsCount: 733, pages: 256,
    published: '2025-02-25', cover: cover('letters-never-sent'),
    description: 'Two former classmates rebuild a friendship over a shared inbox of unsent letters, twenty years after they stopped speaking.',
    tags: ['contemporary', 'slow burn'],
  },
  {
    id: 'b8', title: 'The Cartography of Silence', slug: 'the-cartography-of-silence',
    authorId: 'a4', genre: 'Mystery & Thriller', language: 'English', format: ['PDF'],
    price: 349, mrp: 449, rating: 4.6, reviewsCount: 1050, pages: 372,
    published: '2024-07-30', cover: cover('cartography-silence'), badge: 'Bestseller',
    description: 'A cryptographer is hired to decode a dead man\'s journals — and finds a map to something several powerful people would kill to keep buried.',
    tags: ['espionage', 'puzzle'],
  },
  {
    id: 'b9', title: 'Small Gods of the Office', slug: 'small-gods-of-the-office',
    authorId: 'a3', genre: 'Business', language: 'English', format: ['PDF'],
    price: 279, mrp: 279, rating: 4.1, reviewsCount: 289, pages: 198,
    published: '2025-04-02', cover: cover('small-gods-office'), badge: 'New Release',
    description: 'A witty field guide to the invisible rituals and micro-power-structures that quietly run every modern workplace.',
    tags: ['culture', 'management'],
  },
  {
    id: 'b10', title: 'The Long Thaw', slug: 'the-long-thaw',
    authorId: 'a2', genre: 'Sci-Fi', language: 'English', format: ['PDF'],
    price: 0, mrp: 399, rating: 4.4, reviewsCount: 511, pages: 304,
    published: '2024-12-05', cover: cover('long-thaw'), badge: 'Free',
    description: 'Woken a century early from cryosleep, a terraforming crew must decide whether to finish a mission no one asked them to complete.',
    tags: ['generation ship', 'hope punk'],
  },
  {
    id: 'b11', title: 'Marrow Season', slug: 'marrow-season',
    authorId: 'a1', genre: 'Fiction', language: 'English', format: ['PDF'],
    price: 319, mrp: 419, rating: 4.5, reviewsCount: 601, pages: 288,
    published: '2025-06-20', cover: cover('marrow-season'), badge: 'New Release',
    description: 'In the last summer before the family orchard is sold, three sisters try to harvest one final crop — and a lifetime of unspoken arguments.',
    tags: ['literary', 'sisters'],
  },
  {
    id: 'b12', title: 'The Quiet Signal', slug: 'the-quiet-signal',
    authorId: 'a5', genre: 'Self-Help', language: 'English', format: ['PDF'],
    price: 229, mrp: 299, rating: 4.3, reviewsCount: 356, pages: 164,
    published: '2025-01-28', cover: cover('quiet-signal'),
    description: 'A short, evidence-backed guide to noticing burnout before it arrives, written for people who pride themselves on pushing through it.',
    tags: ['wellbeing', 'burnout'],
  },
].map((b) => ({ ...b, author: authorFor(b.authorId) }));

export const getBookBySlug = (slug) => books.find((b) => b.slug === slug);
export const getBooksByAuthor = (authorId) => books.filter((b) => b.authorId === authorId);
export const getRelatedBooks = (book, count = 4) =>
  books.filter((b) => b.id !== book.id && b.genre === book.genre).slice(0, count);

export const reviewsFor = (bookId) => {
  const seedReviews = [
    { name: 'Ananya R.', rating: 5, text: 'Could not put this down — finished it in two sittings. The pacing in the last third is remarkable.', date: '2026-05-02' },
    { name: 'Jonas T.', rating: 4, text: 'Strong writing throughout, though the middle section drags slightly. Still recommending it to everyone.', date: '2026-04-18' },
    { name: 'Meera K.', rating: 5, text: 'One of the best things I\'ve read this year. The ending genuinely surprised me.', date: '2026-03-30' },
    { name: 'Chris B.', rating: 3, text: 'Good premise, solid prose, but I wanted a bit more from the resolution.', date: '2026-03-11' },
  ];
  return seedReviews.map((r, i) => ({ id: `${bookId}-r${i}`, ...r }));
};
